export default __webpack_public_path__ + "static/media/B4_12.d92e4a7a.mp3";